<button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
	<i class="bento-icon-close-x" aria-hidden="true"></i>
</button>
<h3 id="modal-scrollable-title" class="modal-header h2" data-testid="modalTitle">
	{{modalTitle}} ({{migrationRecordsDetails.length}})
</h3>
<div class="modal-body">
	<ng-container *ngIf="migrationRecordsDetails && migrationRecordsDetails.length">
		<app-table [tableModel]="migrationRecordsDetailsTableModel"></app-table>
	</ng-container>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-primary" (click)="activeModal.close('Close click')">Close</button>
</div>
